<template>
  <div class="page-wrap">
    <!-- 移动端loading -->
    <Loading v-if="isMobile && isLoading" />
    <!-- 视频模块 -->
    <section class="home-video-sec" :class="isMobile ? '' : 'fill-section-1080'">
      <video 
        id="MettaVideo"

        ref="homeVideo"

        class="home-video" 

        autoplay 

        muted 

        loop 

        playsinline

        webkit-playsinline

        x5-playsinline

        x5-video-player-type="h5"

        x5-video-player-fullscreen="false"

        preload="auto"

        :poster="homeVideoPoster"

        @loadedmetadata="pageLoad"

        @canplay="pageLoad"

        @canplaythrough="pageLoad"

        @playing="pageLoad"

        @error="pageLoad"

        :src="homeVideoSrc"
      ></video>
      <button class="play-full-video-btn" @click="playFullVideo">
        观看完整视频
        <img

          class="btn-icon"

          :src="imgUrlPrefix + 'play-icon.png'"

          alt=""

        />
      </button>
      <video
        ref="fullVideo"
        class="full-video"
        controls
        playsinline
        preload="none"
        :src="showFullVideo ? fullVideoSrc : ''"
      ></video>
    </section>

    <!-- 3大车型系列 -->
    <section id="car-series" class="car-series-sec">
      <CarSeriesComponent v-if="isMobile" :car-series-obj="carSeriesBd" />
      <div v-else class="car-series-sec1"><CarSeriesComponent :car-series-obj="carSeriesBd" /></div>
      <CarSeriesComponent :car-series-obj="carSeriesN30" />
      <CarSeriesComponent :car-series-obj="carSeriesUltra" />
    </section>

    <!-- 图文混排组件 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList" />

    <!-- 视频+文字模块 -->
    <section class="video-txt-sec">
      <div class="video-txt-sec-box">
        <!-- pc:3列布局, 移动端1列 -->
        <div class="video-txt-sec-col">
          <div class="video-txt-sec-col-1 video-txt-sec-item" v-for="(item, index) in sec2List.slice(0, 2)" :key="'col-1' + index">
            <video class="video-txt-sec-video" :src="item.src + '.mp4'":poster="item.poster + '.jpg'"autoplay muted loop playsinline webkit-playsinline x5-playsinline preload="none" ></video>
            <div class="video-txt-sec-overlay"></div>
            <div class="video-txt-sec-content">
              <img class="video-txt-sec-icon" :src="item.icon + '.png'" alt="" />
              <div class="video-txt-sec-tag fade-up">{{item.tag}}</div>
              <div class="video-txt-sec-name fade-up">{{item.name}}</div>
              <div class="video-txt-sec-desc fade-up" v-html="item.desc"></div>
            </div>
          </div>
        </div>
        <div class="video-txt-sec-col">
          <div class="video-txt-sec-col-2 video-txt-sec-item" v-for="(item, index) in sec2List.slice(2,3)" :key="'col-2' + index">
            <video class="video-txt-sec-video" :src="item.src + '.mp4'":poster="item.poster + '.jpg'"autoplay muted loop playsinline webkit-playsinline x5-playsinline preload="none"></video>
            <div class="video-txt-sec-overlay"></div>
            <div class="video-txt-sec-content">
              <img class="video-txt-sec-icon" :src="item.icon + '.png'" alt="" />
              <div class="video-txt-sec-tag fade-up">{{item.tag}}</div>
              <div class="video-txt-sec-name fade-up">{{item.name}}</div>
              <div class="video-txt-sec-desc fade-up" v-html="item.desc"></div>
            </div>
          </div>
        </div>
        <div class="video-txt-sec-col">
          <div class="video-txt-sec-col-3 video-txt-sec-item" v-for="(item, index) in sec2List.slice(3, 6)" :key="'col-3' + index">
            <video class="video-txt-sec-video" :src="item.src + '.mp4'":poster="item.poster + '.jpg'"autoplay muted loop playsinline webkit-playsinline x5-playsinline preload="none"></video>
            <div class="video-txt-sec-overlay"></div>
            <div class="video-txt-sec-content">
              <img class="video-txt-sec-icon" :src="item.icon + '.png'" alt="" />
              <div class="video-txt-sec-tag fade-up">{{item.tag}}</div>
              <div class="video-txt-sec-name fade-up">{{item.name}}</div>
              <div class="video-txt-sec-desc fade-up" v-html="item.desc"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 图文混排组件 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList2" />

    <section class="sec1-img2">
      <img 
        :src="isMobile 
          ? imgUrlPrefix + 'm-sec1_2.jpg' 
          : imgUrlPrefix + 'sec1_2.jpg'" 
        alt=""
      />
    </section>

    <!-- 共创计划模块 -->
    <section id="share-plan" class="share-plan-sec">
      <p class="share-plan-title">METTA 共创计划</p>
      <p class="share-plan-desc">这里是越野爱好者的共创场域<br>
从副本设计、赛车改造、生活方式到摄影叙事<br>
每一件作品都可能进入 METTA 的真实世界</p>
      <div class="share-plan-img" :class="isMobile ? '' : 'fill-section-1080'">
        <img :src="`${imgUrlPrefix}${ isMobile ? 'm-sec4_1.jpg' : 'sec4_1.jpg'}`" alt="Metta 共创计划" />
      </div>
    </section>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import CarSeriesComponent from '../components/CarSeriesComponents.vue'
import CarTxtInImgList from '../components/CarTxtInImgList.vue'
import { checkIsMobile } from '../utils/tools.js'
import { videoObserver, videoObserverByClass, destroyVideoObserver } from '../utils/videoPlayObserver'
export default {
  components: {
    Loading,
    CarSeriesComponent,
    CarTxtInImgList,
  },
  mounted() {
    this.checkDevice(); 
    setTimeout(() => {

      this.isLoading = false

    }, 1500)
    this.$nextTick(() => {
      this.tryPlayHomeVideo()

      document.addEventListener('WeixinJSBridgeReady', () => {

        this.tryPlayHomeVideo()

      }, false)

      document.addEventListener('touchstart', () => {

        this.tryPlayHomeVideo()

      }, { once: true })

      setTimeout(() => {

        this.tryPlayHomeVideo()

      }, 800)

      setTimeout(() => {

        this.tryPlayHomeVideo()

      }, 1500)
      videoObserver('MettaVideo');
      videoObserverByClass('video-txt-sec-video');
      setTimeout(() => {

        this.scrollToTarget();

      }, 100);

    });
    window.addEventListener('resize', this.checkDevice);
  },
  watch: {

    '$route.query.scrollTo'() {

      this.scrollToTarget()

    }

  },
  beforeDestroy() {
    destroyVideoObserver()
    window.removeEventListener('resize', this.checkDevice);
    this.stopFullVideo()

    document.onfullscreenchange = null

    document.onwebkitfullscreenchange = null

    document.onkeydown = null
  },
  computed: {
    fullVideoSrc() {

      return this.isMobile

        ? `${this.imgUrlPrefix}m-full-video.mp4`

        : `${this.imgUrlPrefix}full-video.mp4`

    },
    homeVideoSrc() {
      return this.isMobile
        ? `${this.imgUrlPrefix}m-MettaVideo.mp4`
        : `${this.imgUrlPrefix}MettaVideo.mp4`
    },
    homeVideoPoster() {

      return this.isMobile

        ? `${this.imgUrlPrefix}m-video-poster.jpg`

        : `${this.imgUrlPrefix}video-poster.jpg`

    },
    // ultra系列数据
    carSeriesUltra() {
      return {
        logo: this.imgUrlPrefixUltra + 'series-logo.png',
        desc: '赛事级越野专属配置   专业团队调校',
        title: this.isMobile ? 'PERFORMANCE<br>运动赛事系列' : 'PERFORMANCE运动赛事系列',
        series: 'PERFORMANCE',
        carList: [
          { img: this.imgUrlPrefixUltra + 'sec8_1.png', name: 'Ultra', link: 'Ultra'},
          { img: this.imgUrlPrefixUltra + 'sec8_2.png', name: '达喀尔', link: 'UltraT1'},
          { img: this.imgUrlPrefixUltra + 'sec8_3.png', name: '巴丹100', link: 'UltraUtv'},
        ]
      }
    },
    // 图文混排数据
    carTxtInImgList() {
      return [
        {
          tag: '',
          title: this.isMobile ? 'METTA RACING<br>越野挑战赛' : '巴丹100越野挑战赛',
          desc: '穿越巴丹吉林沙漠 T3 超级赛道<br>真实赛段，实时计时<br>线上报名，线下出发，全国积分排名',
          img: this.imgUrlPrefix + 'sec1_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec1_1.jpg',
          color: 'light',
          txtLayout: 'left-top',
        },
      ]
    },
    // 图文混排数据 2
    carTxtInImgList2() {
      return [
        {
          tag: '',
          title: 'METTA CLUB',
          desc: this.isMobile ? '走进 METTA Club，走进越野的真实现场<br>从整车展示到改装套件<br>从车主沙龙到出发前的最后一次检查<br>每一家 Club 都是一座城市里的越野据点' : '走进 METTA Club，走进越野的真实现场<br>从整车展示到改装套件，从车主沙龙到出发前的最后一次检查<br>每一家 Club 都是一座城市里的越野据点',
          img: this.imgUrlPrefix + 'sec3_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_1.jpg',
          color: 'light',
          txtLayout: 'center-top2',
        },
        {
          tag: '',
          title: 'METTA TRAVEL',
          desc: 'METTA Travel 联合专业越野社群<br>打造分级穿越路线<br>提供全程领队、车辆、保险、营地与装备',
          img: this.imgUrlPrefix + 'sec3_2.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_2.jpg',
          color: 'light',
          txtLayout: 'center-top2',
        }
      ]
    },
  },
  data() {
    const imgUrlPrefix = '/assets/images/mettaWorld/';
    const imgUrlPrefixN30 = '/assets/images/n30Loki/';
    const imgUrlPrefixUltra = '/assets/images/ultra/';
    return {
      imgUrlPrefix, // 图片地址前缀
      imgUrlPrefixN30,
      imgUrlPrefixUltra,
      showFullVideo: false,
      isLoading: true,
      isMobile: false,

      // 巴丹吉林系列数据
      carSeriesBd: {
        logo: imgUrlPrefix + 'bd_series_logo.png',
        desc: '科技硬核+智享越野',
        title: 'METTA PRO',
        series: 'METTA PRO',
        carList: [
          { img: imgUrlPrefix + 'bd_series_1.png', name: 'T01 METTA  巴丹吉林', link: 'BadainJaran'},
          { img: imgUrlPrefix + 'bd_series_2.png', name: 'T01 METTA', link: 'BadainJaran'},
        ]
      },

      // n30系列数据
      carSeriesN30: {
        logo: imgUrlPrefixN30 + 'series-logo.png',
        desc: '以「高端定制」为核，共创专属格调',
        title: 'CLASSIC N30° 系列',
        series: 'CLASSIC',
        carList: [
          { img: imgUrlPrefixN30 + 'sec7_1.png', name: 'N30° 环球', link: 'N30Cross'},
          { img: imgUrlPrefixN30 + 'sec7_2.png', name: 'N30° 洛基', link: 'N30Loki'},
          { img: imgUrlPrefixN30 + 'sec7_3.png', name: 'N30° 雅丹', link: 'N30ThreeDoors'},
        ]
      },

      // 视频+文字组合数据
      sec2List: [
        {
          icon: imgUrlPrefix + 'sec2_icon_1',
          tag: 'GAME & APP',
          name: 'SurWorld',
          desc: '由真实驾驶行为生长的AI叙事世界',
          src: imgUrlPrefix + 'sec2_video_1',
          poster: imgUrlPrefix + 'sec2_poster_1'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_2',
          tag: 'GAME & APP',
          name: 'SurMap',
          desc: '真实地理叠加虚拟玩法的越野社交地图',
          src: imgUrlPrefix + 'sec2_video_2',
          poster: imgUrlPrefix + 'sec2_poster_2'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_3',
          tag: 'GAME & APP',
          name: 'MOD工坊',
          desc: '打通实车软硬件的编辑系统',
          src: imgUrlPrefix + 'sec2_video_3',
          poster: imgUrlPrefix + 'sec2_poster_3'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_4',
          tag: 'GAME & APP',
          name: '基地编辑',
          desc: '亲手搭建多人在线的越野基地',
          src: imgUrlPrefix + 'sec2_video_4',
          poster: imgUrlPrefix + 'sec2_poster_4'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_5',
          tag: 'GAME & APP',
          name: '拉力竞速',
          desc: '真实赛道与规则的越野拉力竞技场',
          src: imgUrlPrefix + 'sec2_video_5',
          poster: imgUrlPrefix + 'sec2_poster_5'
        },
        {
          icon: imgUrlPrefix + 'sec2_icon_6',
          tag: 'GAME & APP',
          name: '模拟越野',
          desc: '真实物理驱动的越野模拟闯关游戏',
          src: imgUrlPrefix + 'sec2_video_6',
          poster: imgUrlPrefix + 'sec2_poster_6'
        },
      ],
      
    }
  },
  methods: {
    tryPlayHomeVideo() {

      const video = this.$refs.homeVideo

      if (!video) return

      video.muted = true

      video.playsInline = true

      video.setAttribute('playsinline', 'true')

      video.setAttribute('webkit-playsinline', 'true')

      video.setAttribute('x5-playsinline', 'true')

      const playPromise = video.play()

      if (playPromise && playPromise.catch) {

        playPromise.catch(() => {

          this.isLoading = false

        })

      }

    },
    playFullVideo() {

      this.showFullVideo = true

      this.$nextTick(() => {

        const video = this.$refs.fullVideo

        if (!video) return

        video.currentTime = 0

        video.muted = false

        video.controls = true

        video.onwebkitendfullscreen = () => {

          this.stopFullVideo()

        }

        document.onfullscreenchange = () => {

          if (!document.fullscreenElement) {

            this.stopFullVideo()

          }

        }

        document.onwebkitfullscreenchange = () => {

          if (!document.webkitFullscreenElement) {

            this.stopFullVideo()

          }

        }

        document.onkeydown = (e) => {

          if (e.key === 'Escape') {

            this.stopFullVideo()

          }

        }

        video.play().then(() => {

          if (video.requestFullscreen) {

            video.requestFullscreen()

          } else if (video.webkitRequestFullscreen) {

            video.webkitRequestFullscreen()

          } else if (video.webkitEnterFullscreen) {

            video.webkitEnterFullscreen()

          }

        }).catch(() => {

          this.stopFullVideo()

        })

      })

    },
    stopFullVideo() {

      const video = this.$refs.fullVideo

      if (!video) return

      video.pause()

      video.currentTime = 0

      video.muted = true
      this.showFullVideo = false

    },
    scrollToTarget() {
      const targetId = this.$route.query.scrollTo
      console.log('targetId:', targetId)

      if (!targetId) return

      setTimeout(() => {
        const el = document.getElementById(targetId)
        console.log('el:', el)
        console.log('offsetTop:', el && el.offsetTop)

        if (!el) return

        window.scrollTo({
          top: el.offsetTop - 80,
          behavior: 'auto'
        })
      }, )
    },

    checkDevice() {

      this.isMobile = checkIsMobile()

    },

    pageLoad() {

      this.isLoading = false
      this.tryPlayHomeVideo()

    }

    },

}
</script>

<style lang="less" scoped>
.page-wrap {
  font-family: 'TsangerYunHei', sans-serif;
  .sec1-img2 {
    width: 100%;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
  .home-video-sec {
    position: relative;
    .play-full-video-btn {

      position: absolute;

      left: 50%;

      bottom: 5vw;

      transform: translateX(-50%);

      z-index: 5;

      padding: 12px 30px;

      background: rgba(0, 0, 0, 0.55);

      color: #fff;

      font-size: 16px;

      border: 1px solid rgba(255,255,255,0.7);

      cursor: pointer;
      display: flex;      

      align-items: center;   

      justify-content: center;

      gap: 8px;

    }
    .btn-icon {

      width: 16px;

      height: 16px;

    }

    .full-video {

      position: fixed;

      left: 0;

      top: 0;

      width: 1vw;

      height: 1vh;

      object-fit: contain;

      background: #000;

    }
    .home-video {
      position: absolute; inset: 0;
      width: 100%; height: 100%;
      object-fit: cover;
      z-index: 0;
    }
  }
  .car-series-sec {
    background-color: #E6E8E7;
    .car-series-sec1 {
      width: 65vw;
      margin: 0 auto;
    }
  }

  .video-txt-sec {
    min-width: 1200px;
    padding: 9.07vw 5.67vw 11.17vw;
    background-image: url('/assets/images/ultraT1/sec2_bg.jpg');
    .video-txt-sec-box {
      width: 100%;
      margin: 0 auto;
      display: flex;
      aspect-ratio: 1720 / 1285; // 保持宽高比
      height: auto;
      .video-txt-sec-col {
        display: flex;
        flex-direction: column;
        flex: 1;

        .video-txt-sec-item {
          position: relative;
          overflow: hidden;
          .video-txt-sec-overlay {
            position: absolute;
            inset: 0;
            background-color: rgba(0, 0, 0, 0.5);
          }
          .video-txt-sec-content {
            position: absolute;
            inset: 1.95vw;
            font-weight: @fw2;
            .video-txt-sec-icon {
              width: 4.88vw;
              height: 4.88vw;
            }
            .video-txt-sec-tag {
              margin-top: 0.78vw;
              color: #fff;
              font-size: clamp(12px, 0.83vw, 16px);
              text-transform: uppercase;
            }
            .video-txt-sec-name {
              margin-top: 0.78vw;
              color: #C8FC00;
              font-size: clamp(32px, 2.5vw, 48px);
            }
            .video-txt-sec-desc {
              margin-top: 0.78vw;
              color: rgba(255, 255, 255, 0.7);
              font-size: clamp(16px, 1.25vw, 24px);
            }
          }
          .video-txt-sec-pic {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .video-txt-sec-video {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .video-txt-sec-col-1 {
          height: 50%;
        }
        .video-txt-sec-col-2 {
          height: 100%;
        }
        .video-txt-sec-col-3 {
          flex: 1;
        }
      }
    }
  }
  
  .share-plan-sec {
    overflow: hidden;
    background-color: black;
    color: white;
    text-align: center;
    font-weight: @fw2;
    .share-plan-title {
      margin-top: 4.79vw;
      font-size: clamp(32px, 2.5vw, 48px);
    }
    .share-plan-desc {
      margin-top: 0.83vw;
      margin-bottom: 4.53vw;
      // color: rgba(255, 255, 255, 0.7);
      font-size: clamp(16px, 1.25vw, 24px);
    }
  }
}
@media (max-width: @mobile-width) {
  .page-wrap {
    .sec1-img2 {

      img {

        width: 100%;

        height: auto;

      }

    }
    .home-video-sec {
      position: relative;
      height: 100vh;
      .play-full-video-btn {

        bottom: 12vw;

        font-size: 4.26vw;

        padding: 2.67vw 5.33vw;

      }
      .btn-icon {

        width: 4vw;

        height: 4vw;

      }
    }

    .video-txt-sec {
      width: 100%;
      padding: 9.6vw 5.33vw ;
      background-image: url('/assets/images/ultraT1/sec2_bg.jpg');
      background-size: cover;
      background-position: left center;
      .video-txt-sec-box {
        width: auto;
        display: flex;
        aspect-ratio: auto;
        height: auto;
        flex-direction: column;
        .video-txt-sec-col {
          display: flex;
          flex-direction: column;
          flex: none;
          width: 89.33vw;
          row-gap: 5.33vw;
          .video-txt-sec-item {
            position: relative;
            overflow: hidden;
            width: 89.33vw;
            height: 65.87vw;
            .video-txt-sec-content {
              position: absolute;
              inset: 3.47vw;
              font-weight: @fw2;
              .video-txt-sec-icon {
                width: 15.47vw;
                height: 15.47vw;
              }
              .video-txt-sec-tag {
                margin-top: 2.4vw;
                font-size: 2.4vw;
              }
              .video-txt-sec-name {
                margin-top: 2.4vw;
                color: #C8FC00;
                font-size: 7.47vw;
                font-weight: @fw1;
              }
              .video-txt-sec-desc {
                margin-top: 2.4vw;
                font-size: 3.73vw;
              }
            }
            .video-txt-sec-pic {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .video-txt-sec-video {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .video-txt-sec-col-1 {
            height: 65.87vw;
          }
          .video-txt-sec-col-2 {
            height: 65.87vw;
            margin: 5.33vw 0;
          }
          .video-txt-sec-col-3 {
            flex: none;
            height: 65.87vw;
          }
        }
      }
    }
    
    .share-plan-sec {
      font-weight: @fw3;
      .share-plan-title {
        margin-top: 18.67vw;
        font-size: 8.53vw;
      }
      .share-plan-desc {
        font-size: 4.26vw;
        margin-top: 1.6vw;
        margin-bottom: 18.67vw;
      }
      .share-plan-img {
        width: 100%;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>